import { render, staticRenderFns } from "./WatchSymbols.vue?vue&type=template&id=4b898ffe&"
import script from "./WatchSymbols.vue?vue&type=script&lang=ts&"
export * from "./WatchSymbols.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports